import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';
import { useIsHongKongIp } from '../../../hooks/useIsHongKongIp';

export default function ContactCTASection() {
  const { t } = useTranslation();
  const { canShowRestrictedContent } = useIsHongKongIp();

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {t('contactCTA.title')}
          </h2>
          <p className="text-xl mb-12 opacity-90">
            {t('contactCTA.subtitle')}
          </p>

          <div className={`grid ${canShowRestrictedContent ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-8 mb-12`}>
            {/* Phone */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">{t('contactCTA.phoneTitle')}</h3>
              <p className="text-gray-300 mb-6">{t('contactCTA.phoneDesc')}</p>
              <Button variant="outline" className="w-full border-white text-white hover:bg-white hover:text-gray-900 whitespace-nowrap">
                {t('contactCTA.callNow')}
              </Button>
            </div>

            {/* Email */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">{t('contactCTA.emailTitle')}</h3>
              <p className="text-gray-300 mb-6">{t('contactCTA.emailDesc')}</p>
              <Button variant="outline" className="w-full border-white text-white hover:bg-white hover:text-gray-900 whitespace-nowrap">
                {t('contactCTA.sendMsg')}
              </Button>
            </div>

            {/* Chat is unavailable for HK / US visitors. */}
            {canShowRestrictedContent && (
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-message-3-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">{t('contactCTA.chatTitle')}</h3>
                <p className="text-gray-300 mb-2">{t('contactCTA.chatDesc')}</p>
                <p className="text-sm text-orange-300 mb-4">{t('contactCTA.available')}</p>
                <Button variant="primary" className="w-full whitespace-nowrap">
                  {t('contactCTA.startChat')}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
